






























import ApiHelper from 'api-helper';
import { State } from 'vuex-class';
import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { Patient } from '@/models/patient';
import { UserTreatment } from '@/models/user-treatment';
import Toast from '@common/helpers/toast';
import { sortPlansByPriority } from '@common/helpers/planSort';
import PageLoader from '@components/common/PageLoader.vue';
import WindowSizeMixin from '@common/mixins/WindowSizeMixin';
import PlanItem from './PlanItem.vue';

@Component({
  components: {
    PageLoader,
    PlanItem,
  },
})
export default class PopupConfirm extends Mixins(WindowSizeMixin) {
  @Prop(String) readonly name!: string;
  @Prop(Boolean) readonly isShow!: boolean;

  get modalWidth(): string | number {
    return this.windowWidth <= 767 ? '100%' : 600;
  }

  @State((state) => state.patient_detail.data) currentPatient!: Patient;
  @State((state) => state.patient_detail.data) patient!: Patient;
  @State((state) => state.treatment_detail.data)
  activeTreatment!: UserTreatment;

  listPlanByMenu: any[] = [];

  private get sortedListPlanByMenu(): any[] {
    const changedPlanId = this.activeTreatment?.plan?.id ?? null;
    return sortPlansByPriority(this.listPlanByMenu, changedPlanId);
  }
  isTableLoading = false;

  paginate = {
    page: 1,
    per_page: 20,
    last_page: 1,
  };

  filterParams = {
    with: 'medicines',
    select_fields: 'id,name,price_first',
    clinic_id: null,
    karte_status: 1,
    has_plans: 1,
    clinic_ids: [] as number[],
    ids_not_in: [] as number[],
  };

  get queryParams() {
    return {
      ...this.filterParams,
      ...this.paginate,
    };
  }

  scrollY = window.innerHeight - 100;
  planListTableEl: Element | null = null;

  mounted() {
    this.getListPlansByMenu();
    window.addEventListener('resize', this.updateScrollY);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.updateScrollY);
    this.planListTableEl?.removeEventListener('scroll', this.handleScroll);
  }

  @Watch('isShow')
  private isShowChanged(val: boolean) {
    if (val) {
      this.listPlanByMenu = [];
      this.paginate.page = 1;
      this.getListPlansByMenu();

      setTimeout(() => {
        this.planListTableEl = document.querySelector('div.plan-list-container');
        this.planListTableEl?.addEventListener('scroll', this.handleScroll);
      }, 100);
    } else {
      this.planListTableEl?.removeEventListener('scroll', this.handleScroll);
    }
  }

  private updateScrollY() {
    this.scrollY = window.innerHeight - 100;
  }

  // No-75 Divide plan items by menu
  // private updateFilterParams() {
  //   this.filterParams.clinic_ids = this.currentPatient?.clinics?.length
  //     ? [this.currentPatient.clinics[0].id]
  //     : [];

  //   this.filterParams.ids_not_in = this.activeTreatment?.menu?.id
  //     ? [this.activeTreatment.menu.id]
  //     : [];
  // }

  private getListPlansByMenu() {
    if (!this.activeTreatment?.id) {
      return;
    }
    this.isTableLoading = true;

    // No-75 Divide plan items by menu
    // if (this.paginate.page > this.paginate.last_page && this.paginate.last_page > 1) {
    //   this.isTableLoading = false;
    //   return;
    // }
    const payload = { user_treatment_id: this.activeTreatment.id, with: ['medicines:id,name,usage'] };

    ApiHelper.getApi('PatientV2Api')
      .getPlansByPatientId(this.patient.id, payload)
      .then((res) => {
        this.listPlanByMenu = res.data;

        // No-75 Divide plan items by menu
        // const lastPage = res ? res.meta.last_page : 1;
        // if (this.paginate.page * this.paginate.per_page > this.listPlanByMenu.length + res.data.length - 1) {
        //   this.listPlanByMenu = [...this.listPlanByMenu, ...res.data];
        // }

        // this.paginate = {
        //   ...this.paginate,
        //   page: lastPage >= this.paginate.page ? this.paginate.page + 1 : this.paginate.page,
        //   last_page: lastPage,
        // };
      })
      .catch((error: any) => {
        Toast.error(error.response.data.message);
      })
      .finally(() => {
        this.isTableLoading = false;
      });
  }

  private handleScroll(event: Event) {
    const container = event.target as HTMLElement;
    const { scrollTop, scrollHeight, clientHeight } = container;

    if (scrollTop + clientHeight >= scrollHeight - 10 && !this.isTableLoading) {
      this.getListPlansByMenu();
    }
  }

  private closePlanListModal() {
    this.$modal.hide(this.name);
  }

  private convertMedicineArrToString(record: any): string {
    return record?.medicines?.length
      ? record.medicines.map((med: any) => med.name).join(', ')
      : '';
  }
}
